/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import func from "summernote/src/js/core/func";

require('./bootstrap');
import Vue from 'vue'
import moment from "moment";
import Vuelidate from 'vuelidate'
import VueCropper from 'vue-cropperjs';
import Paginate from 'vuejs-paginate'
import store from './store';
import convertImage from "./filters/convertImage.filter";
import 'lightbox2/dist/css/lightbox.min.css'
import 'cropperjs/dist/cropper.css';
import 'swiper/css/swiper.css'
// import router from './router';
// import { BootstrapVue } from 'bootstrap-vue'
// import VueCarousel from 'vue-carousel';
// import VueNumber from 'vue-number-animation'
// import VueTheMask from 'vue-the-mask'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import Lightbox from 'vue-easy-lightbox'
import Lightbox from 'lightbox2'
// import { Navigation } from "swiper";

// Vue.use(VueNumber);
Vue.use(Lightbox);
// Vue.use(VueCarousel);
// Vue.use(BootstrapVue);
// Vue.use(VueAwesomeSwiper);
// Vue.use(VueCarousel);
// Vue.use(BootstrapVue);

Vue.use(Vuelidate);

Vue.filter( 'convertImage', convertImage );
Vue.config.productionTip = false;
window.moment = moment;
// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Функции для получения base64 из инпута
File.prototype.convertToBase64 = function (callback) {
    let reader = new FileReader();
    reader.onloadend = function (e) {
        callback(e.target.result, e.target.error);
    };
    reader.readAsDataURL(this);
};

Vue.component('vue-cropper', VueCropper);
Vue.component('paginate', Paginate);
Vue.component('register-component', require('./components/auth/RegisterComponent.vue').default);
Vue.component('login-heading-component', require('./components/auth/LoginHeading.vue').default);
Vue.component('login-component', require('./components/auth/LoginComponent.vue').default);
Vue.component('contacts', require('./components/Contacts.vue').default);
Vue.component('forgot-component', require('./components/auth/ForgotComponent.vue').default);
Vue.component('global-notification', require('./components/GlobalNotification.vue').default);
Vue.component('header-component', require('./components/HeaderComponent.vue').default);
Vue.component('main-menu', require('./components/MainMenu/index.vue').default);

Vue.component('volunteer-backend-component', require('./components/VolunteerBackendComponent.vue').default);
Vue.component('volunteer-backend-component-nav', require('./components/VolunteerBackendComponentNav.vue').default);
Vue.component('volunteer-backend-profile-heading', require('./components/VolunteerBackendProfileHeading.vue').default);
Vue.component('volunteer-actual-pets-component', require('./components/VolunteerActualPets.vue').default);

Vue.component('publication-create', require('./components/Publication/PublicationCreate').default);
Vue.component('publication-pet', require('./components/Publication/Pet/index.vue').default);
Vue.component('publication-personal', require('./components/Publication/Personal/index.vue').default);
Vue.component('publication-project', require('./components/Publication/Project/index.vue').default);
Vue.component('publication-facility', require('./components/Publication/Facilities/index.vue').default);
Vue.component('publication-homestays', require('./components/Publication/Homestays/index.vue').default);

Vue.component('organization-heading', require('./components/Organizations/OrganizationHeading').default);
Vue.component('organization-backend', require('./components/Organizations/OrganizationBackendComponent').default);
Vue.component('organization-profile', require('./components/Organizations/OrganizationProfile').default);

Vue.component('user-heading', require('./components/Profile/user/UserHeading').default);
Vue.component('user-backend', require('./components/Profile/user/UserBackend').default);

Vue.component('volunteer-finances', require('./components/VolunteerFinances.vue').default);
Vue.component('volunteer-finance-report-component', require('./components/VolunteerFinanceReportComponent.vue').default);

Vue.component('catalog-component', require('./components/CatalogComponent/index.vue').default);
Vue.component('random-pets-or-projects-component', require('./components/RandomPetsOrProjectsComponent.vue').default);
Vue.component('pet-and-project-component', require('./components/PetAndProjectComponent.vue').default);
Vue.component('pet-and-project-breadcrumbs-component', require('./components/PetAndProjectBreadcrumbsComponent.vue').default);
Vue.component('check-pay-page-component', require('./components/CheckPayPageComponent.vue').default);

Vue.component('header-main-page', require('./components/HeaderMainPage.vue').default);
Vue.component('Animals', require('./components/Animals.vue').default);
Vue.component('Heroes', require('./components/Heroes.vue').default);
Vue.component('Report', require('./components/Report.vue').default);
Vue.component('Sponsors', require('./components/Sponsors.vue').default);
Vue.component('FacilitiesSlider', require('./components/FacilitiesMainPage').default);
Vue.component('Else', require('./components/Else.vue').default);
Vue.component('Cookies', require('./components/Cookies.vue').default);
Vue.component('search-home', require('./components/SearchHome.vue').default);
Vue.component('how-help', require('./components/HowHelp.vue').default);

Vue.component('partners', require('./components/Partners.vue').default);
Vue.component('us-write', require('./components/UsWrite.vue').default);
Vue.component('how-work', require('./components/HowWork.vue').default);
Vue.component('animals-list', require('./components/AnimalsList.vue').default);
Vue.component('pet-and-and-project-thanks-tab-component', require('./components/PetAndProjectThanksTabComponent.vue').default);
Vue.component('pet-and-and-project-transactions-tab-component', require('./components/PetAndProjectTransactionsTabComponent.vue').default);
Vue.component('pet-and-and-project-events-tab-component', require('./components/PetAndProjectEventsTabComponent.vue').default);
Vue.component('pet-and-and-project-history-tab-component', require('./components/PetAndProjectHistoriesTabComponent.vue').default);

Vue.component('blog-page', require('./components/Blog/index.vue').default);
Vue.component('blog-articles', require('./components/Blog/BlogArticles.vue').default);

Vue.component('post-meta', require('./components/Blog/Post/PostMeta.vue').default);
Vue.component('post-info', require('./components/Blog/Post/PostInfo.vue').default);
Vue.component('post-aside', require('./components/Blog/Post/PostAside.vue').default);
Vue.component('post-comments', require('./components/Blog/Post/PostComments.vue').default);
Vue.component('post-categories', require('./components/Blog/Post/PostCategories.vue').default);

Vue.component('share-social-modal', require('./components/Blog/ShareSocialModal.vue').default);

Vue.component('knowledge-nav', require('./components/KnowledgeBase/KnowledgeNav.vue').default);
Vue.component('blog-knowledge-nav', require('./components/Blog/BlogKnowledgeNav.vue').default);
Vue.component('knowledge-base', require('./components/KnowledgeBase/index.vue').default);
Vue.component('donors', require('./components/Donors/Donors.vue').default);
Vue.component('homestay', require('./components/Homestays/Homestay.vue').default);
Vue.component('photo-and-pr', require('./components/Facilities/PhotoAndPrFacilities.vue').default);
Vue.component('auto-help', require('./components/Facilities/AutoHelpFacilities.vue').default);
Vue.component('giveaway', require('./components/Facilities/GiveAwayFacilities.vue').default);

Vue.component('not-found', require('./components/NotFound.vue').default);
Vue.component('agreement', require('./components/Agreement.vue').default);
Vue.component('need-contractor-review-modal', require('./components/NeedContractorReviewModal.vue').default);
Vue.component('accountant-component', require('./components/admin/AccountantComponent.vue').default);

Vue.component('expenditure-request-create', require('./components/ExpenditureRequest/ExpenditureRequestCreate.vue').default);
Vue.component('fandy-widget', require('./components/FandyWidget.vue').default);

const bootstrap = async function () {
    await store.dispatch('fetchTranslations');

    new Vue({
        el: '#app',
        store,
        // router,
        created(){
            let condition = ((window.location.href.indexOf('/volunteer/') === -1 && window.location.href.indexOf('/user/') === -1) &&
                (this.currentUserData && this.$store.getters.getterProfileTab !== 'profile-component'))

            if(condition){
                this.$store.commit('setterProfileTab', 'profile-component')
            }

        },
        async mounted() {


            if( window.auth ) await this.$store.dispatch('loadUserDataFromServer');

            if( ! window.auth ) this.$store.commit( 'setUserData', '' );

            if( window.authUserProfileView ) this.$store.commit( 'setUserProfileType', window.authUserProfileView )

            document.body.classList.remove('loading')

            setTimeout(()=>{
                document.querySelector('.preloader').remove();
            }, 1000)

        },

        computed: {
            currentUserData() {
                return this.$store.getters.getUserData;
            },
        },
    });
}

bootstrap();





